import { useEffect, useRef } from "react";

const DRAG_THRESHOLD_PX = 5;

const useSuppressClickOnDrag = () => {
  const dragStateRef = useRef({
    isPointerDown: false,
    moved: false,
    startX: 0,
    startY: 0,
  });

  useEffect(() => {
    const handlePointerMove = (event) => {
      const state = dragStateRef.current;
      if (!state.isPointerDown) {
        return;
      }

      const deltaX = Math.abs(event.clientX - state.startX);
      const deltaY = Math.abs(event.clientY - state.startY);

      if (Math.max(deltaX, deltaY) > DRAG_THRESHOLD_PX) {
        state.moved = true;
      }
    };

    const handlePointerUp = () => {
      const state = dragStateRef.current;
      state.isPointerDown = false;
      state.startX = 0;
      state.startY = 0;

      requestAnimationFrame(() => {
        state.moved = false;
      });
    };

    window.addEventListener("pointermove", handlePointerMove);
    window.addEventListener("pointerup", handlePointerUp);
    window.addEventListener("pointercancel", handlePointerUp);

    return () => {
      window.removeEventListener("pointermove", handlePointerMove);
      window.removeEventListener("pointerup", handlePointerUp);
      window.removeEventListener("pointercancel", handlePointerUp);
    };
  }, []);

  const onPointerDownCapture = (event) => {
    const state = dragStateRef.current;
    state.isPointerDown = true;
    state.moved = false;
    state.startX = event.clientX;
    state.startY = event.clientY;
  };

  const onClickCapture = (event) => {
    if (!dragStateRef.current.moved) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    dragStateRef.current.moved = false;
  };

  const onDragStartCapture = (event) => {
    event.preventDefault();
  };

  return {
    onPointerDownCapture,
    onClickCapture,
    onDragStartCapture,
  };
};

export default useSuppressClickOnDrag;
